import { render, staticRenderFns } from "./DvrServerDialog.vue?vue&type=template&id=1780b6a6&"
import script from "./DvrServerDialog.vue?vue&type=script&lang=js&"
export * from "./DvrServerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports